/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { apiUrl } from "../../constants";
import { TrackGoogleAnalyticsEvent } from "../../helpers/InitializeGoogleAnalytics";
import createGoogleAnalyticsTemplateName from "../../helpers/createGoogleAnalyticsTemplateName";
import axios from "axios";
import styles from "./SpecsheetsPage.module.css";
import Header from "../../components/header/Header";
import Sheet from "../../components/sheet/Sheet";
import Sheet2 from "../../components/sheet2/Sheet2";
import GeneralInformation from "../../components/generalInformation/GeneralInformation";
import Footer from "../../components/footer/Footer";
import UpdateForm from "../../components/dynamicForm/updateForm/UpdateForm";
import UpdateForm2 from "../../components/dynamicForm/updateForm2/UpdateForm2";

// Here we receive the param from app.js and set is as param to be transferred to Sheet.js. Here we also combine three components together on one page
const SpecsheetPage = () => {
  const [name, setName] = useState("");
  const [additionalTemplateInformation, setAdditionalTemplateInformation] =
    useState("");
  const [response, setResponse] = useState([]);
  const [previewPages, setPreviewPages] = useState([]);
  const [creatives, setCreatives] = useState([]);
  const [previewLinks, setPreviewLinks] = useState([]);
  const [downloadLinks, setDownloadLinks] = useState([]);
  const [display, setDisplay] = useState(false);
  const [lastUpdate, setLastUpdate] = useState("");
  const [specsheet, setSpecsheet] = useState(null);
  const [showModifyForm, toggleShowModifyForm] = useState(false);
  let navigate = useNavigate();
  const [paramDsVersion, setParamsDsVersion] = useState();
  let { active, dsVersion, id } = useParams();

  useEffect(() => {
    setParamsDsVersion(dsVersion);
  }, [paramDsVersion]);

  const showNavigation = false;
  let getUrl = `${apiUrl}/api/specsheets/${active}/${id}`;
  if (dsVersion !== undefined && parseInt(dsVersion) === 2) {
    getUrl = `${apiUrl}/api/specsheets/${active}/${id}/version/${dsVersion}`;
  }

  // Here set the google analytics tracking
  useEffect(() => {
    if (name !== "") {
      TrackGoogleAnalyticsEvent(
        "view",
        `viewed: ${createGoogleAnalyticsTemplateName(name)}`,
        name
      );
    }
  }, [name]);

  /**
   * Here we receive the id and active state from the param and
   * get the specsheet data and we set the data.
   * We always send a token now even if it is not needed.
   * In order to get an error from the backend if a notActive specsheets
   * is requested by a non Admin user.
   */
  useEffect(() => {
    async function getData() {
      const jwtToken = localStorage.getItem("token");
      try {
        const { data } = await axios.get(
          getUrl,
          {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
            },
          }
        );
        setSpecsheet(data[0].specsheet);
        setLastUpdate(data[0].specsheet.lastUpdate);
        setAdditionalTemplateInformation(
          data[0].specsheet.additionalTemplateInformation
        );
        setResponse(data[0].specsheet);
        setCreatives(data[0].specsheet.creatives);
        setName(data[0].specsheet.templateName);
        setPreviewLinks(data[0].specsheet.previews);
        setDownloadLinks(data[0].specsheet.downloadFormat);
        setPreviewPages(data[0].specsheet.previewPages);

        setDisplay(true);
      } catch (e) {
        console.error(e);
        setDisplay(false);
        navigate("*");
      }
    }
    if (id) {
      getData();
    }
  }, [id]);

  return (
    <div>
      {!showModifyForm && dsVersion === undefined && (
        <Header showNavigation={showNavigation} />
      )}
      {dsVersion === "2" && (
        <Header showNavigation={showNavigation} specsheetStyle />
      )}
      {display && (
        <div className={styles["specsheet-container"]}>
          {!showModifyForm && dsVersion === undefined && (
            <Sheet
              name={name}
              lastUpdate={lastUpdate}
              creatives={creatives}
              additionalTemplateInformation={additionalTemplateInformation}
              previewLinks={previewLinks}
              downloadLinks={downloadLinks}
              previewPages={previewPages}
              toggleShowModifyForm={toggleShowModifyForm}
            />
          )}
          {!showModifyForm && dsVersion === "2" && (
            <Sheet2
              name={name}
              specsheet={specsheet}
              lastUpdate={lastUpdate}
              creatives={creatives}
              additionalTemplateInformation={additionalTemplateInformation}
              previewLinks={previewLinks}
              downloadLinks={downloadLinks}
              previewPages={previewPages}
              toggleShowModifyForm={toggleShowModifyForm}
            />
          )}
          {showModifyForm && dsVersion === undefined && (
            <UpdateForm
              response={response}
              id={id}
              toggleShowModifyForm={toggleShowModifyForm}
            />
          )}
          {showModifyForm && dsVersion === "2" && (
            <UpdateForm2
              response={response}
              id={id}
              toggleShowModifyForm={toggleShowModifyForm}
            />
          )}
          {!showModifyForm && dsVersion === undefined && <GeneralInformation name={name} />}
          {!showModifyForm && dsVersion === undefined && (
            <Footer />
          )}
          {!showModifyForm && dsVersion === "2" && (
            <Footer specsheetStyle />
          )}
        </div>
      )}
    </div>
  );
};

export default SpecsheetPage;
